<template>
  <div :class="$style.containerForm">
    <div :class="$style.containerText">
      <div :class="$style.containerTextHnumber">
        <PdsTexting format="h1">
          {{title}}
        </PdsTexting>
      </div>
      <div :class="$style.containerTextSubHnumber">
        <PdsTexting format="body">
          {{subTitle}}
        </PdsTexting>
      </div>
      <hr :class="$style.hLine">
    </div>
    <div :id="$style.checks">
      Crea tu clave de acceso <span :class="$style.required">*</span>
      <PdsTexting format="body4">
        <img
        v-show="!greenCheck.check1"
        width="16"
        src="@/assets/images/check.svg"
        alt="check"
        ref="check1"/>
        <img
        v-show="greenCheck.check1"
        width="16"
        src="@/assets/images/check_green.svg"
        alt="check"
        ref="check1"/>
        Desde 8 caracteres
      </PdsTexting>
      <PdsTexting format="body4">
        <img
        v-show="!greenCheck.check2"
        width="16"
        src="@/assets/images/check.svg"
        alt="check"
        ref="check1"/>
        <img
        v-show="greenCheck.check2"
        width="16"
        src="@/assets/images/check_green.svg"
        alt="check"
        ref="check1"/>
      Debe contener una letra mayúscula
      </PdsTexting>
      <PdsTexting format="body4">
        <img
        v-show="!greenCheck.check3"
        width="16"
        src="@/assets/images/check.svg"
        alt="check"
        ref="check1"/>
        <img
        v-show="greenCheck.check3"
        width="16"
        src="@/assets/images/check_green.svg"
        alt="check"
        ref="check1"/>
      Debe contener al menos un número
      </PdsTexting>
      <PdsTexting format="body4">
        <img
        v-show="!greenCheck.check4"
        width="16"
        src="@/assets/images/check.svg"
        alt="check"
        ref="check1"/>
        <img
        v-show="greenCheck.check4"
        width="16"
        src="@/assets/images/check_green.svg"
        alt="check"
        ref="check1"/>
        Debe contener un caracter especial
      </PdsTexting>
      <PdsTexting format="body4">
        <img
        v-show="!greenCheck.check6"
        width="16"
        src="@/assets/images/check.svg"
        alt="check"
        ref="check1"/>
        <img
        v-show="greenCheck.check6"
        width="16"
        src="@/assets/images/check_green.svg"
        alt="check"
        ref="check1"/>
        No debe contener tu nombre
      </PdsTexting>
      <PdsTexting format="body4">
        <img
        v-show="!greenCheck.check7"
        width="16"
        src="@/assets/images/check.svg"
        alt="check"
        ref="check1"/>
        <img
        v-show="greenCheck.check7"
        width="16"
        src="@/assets/images/check_green.svg"
        alt="check"
        ref="check1"/>
        No debe contener tu RUT
      </PdsTexting>
    </div>
    <div :class="$style.input">
      <Input
        id="claveCliente"
        label="Ingresa una clave"
        aria-label="Ingresa una clave"
        required
        @error="(err) => error.claveCliente = err"
        @data="writePassword"
        typeinput="password"
        maxlength="20"
      />
    </div>
    <div :class="$style.input">
      <Input
        id="reClaveCliente"
        label="Repite la misma clave para confirmar"
        aria-label="Repite la misma clave para confirmar"
        required
        @error="(err) => error.reClaveCliente = err"
        @data="writeRePassword"
        typeinput="password"
        maxlength="20"
        :errorMessage="this.error.differentPasswords"
      />
    </div>
    <div :class="$style.containerSubForm">
      <PdsButton
        :label="this.titleBtn"
        aria-label="Crear mi cuenta, botón."
        role=primary
        :class="$style.button"
        @click="emitPass"
        :disabled="!validatePassword"
      />
    </div>
  </div>
</template>

<script>
import PdsButton from '@vue-pds/button';
import Input from '@/components/Input';
import PdsTexting from '@vue-pds/texting';

export default {
  name: 'CreatePasswordInput',
  components: {
    PdsButton,
    Input,
    PdsTexting,
  },
  data() {
    return {
      data: {
        password: null,
        repassword: null,
      },
      error: {
        password: null,
        repassword: null,
        differentPasswords: null,
      },
      greenCheck: {
        check0: false,
        check1: false,
        check2: false,
        check3: false,
        check4: false,
        check6: true,
        check7: true,
      },
      load: false,
    };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      required: false,
    },
    subTitle: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    rut: {
      type: String,
      required: false,
      default: '',
    },
    titleBtn: {
      type: String,
      required: false,
    },
  },
  methods: {
    writePassword(pass) {
      this.data.password = pass;
      this.error.differentPasswords = pass.value !== this.data.repassword.value ? 'Contraseñas no coinciden' : null;
    },
    writeRePassword(pass) {
      this.data.repassword = pass;
      this.error.differentPasswords = this.data.password.value !== pass.value ? 'Contraseñas no coinciden' : null;
    },
    emitPass() {
      this.$emit('data', { password: this.data.password.value });
    },
    changeColor(index, color) {
      this.greenCheck[`check${index}`] = color;
    },
  },
  computed: {
    validatePassword() {
      const pass = this.data.password === null ? false
        : (this.data.password.value !== null && this.data.password.value !== '');
      const repass = this.data.repassword === null ? false
        : (this.data.repassword.value !== null && this.data.repassword.value !== '');
      let errorPassword = false;

      // validar contraseña:
      if (!pass || !repass) {
        this.changeColor(0, false);
      } else {
        this.changeColor(0, true);
      }

      if (pass) {
        // Desde 8 caracteres
        if (this.data.password.value.length < 8) {
          this.changeColor(1, false);
        } else {
          this.changeColor(1, true);
        }

        // check Debe contener una letra mayúscula
        const testM = /[A-Z]/g;
        if (!this.data.password.value.match(testM)) {
          this.changeColor(2, false);
        } else {
          this.changeColor(2, true);
        }

        // check Debe contener al menos un número
        const testN = /\d/g;
        if (!this.data.password.value.match(testN)) {
          this.changeColor(3, false);
        } else {
          this.changeColor(3, true);
        }

        // check Debe contener un caracter especial
        this.changeColor(4, true);
        const testS = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/g;
        if (!this.data.password.value.match(testS)) {
          this.changeColor(4, false);
        } else {
          this.changeColor(4, true);
        }

        // check No puede ser una clave ya usada   (No hacer)

        // check No debe contener tu nombre
        this.changeColor(6, true);
        const names = this.name.trim().split(' ');

        const namesLength = names.length;
        const namesAux = [];
        for (let i = 0; i < namesLength; i += 1) {
          if (names[i].length > 0) {
            const nameNormalize = names[i].normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            namesAux.push(nameNormalize.toLowerCase());
          }
        }

        for (let i = 0; i < namesAux.length; i += 1) {
          // true --> does not match
          if (this.data.password.value.toLowerCase().match(namesAux[i]) === null) {
            this.changeColor(6, true);
          } else {
            this.changeColor(6, false);
            break;
          }
        }

        // check No debe contener tu RUT
        this.changeColor(7, true);
        if (!this.data.password.value.match(this.rut)) {
          this.changeColor(7, true);
        } else {
          this.changeColor(7, false);
        }

        // validar contraseña iguales
        if (repass && this.data.password.value !== this.data.repassword.value) {
          errorPassword = true;
        }
      } else {
        this.changeColor(1, false);
        this.changeColor(2, false);
        this.changeColor(3, false);
        this.changeColor(4, false);
        this.changeColor(6, false);
        this.changeColor(7, false);
      }

      if (!errorPassword && Object.values(this.greenCheck).every(val => val === true)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" module>

.containerForm {
  width: 600px;
  margin: 0 auto;

  & .containerText {
    padding: 30px 0;

    & .containerTextHnumber {
      font-size: 60px;
    }

    & .containerTextSubHnumber {
      padding: 25px 0;
      font-size: 22px;
    }

    & .hLine {
      width: 57px;
      height: 3px;
      margin: 0;
      background: #ffc82e;
      border: 0;
    }
  }

  & .containerSubForm {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;

    & .button {
      align-content: center;
      height: 42px;
      padding: 0 110px;
      margin: 20px 0;
      text-align: center;
    }
  }
}

@media (min-width: 500px) and (max-width: 940px) {
  .containerForm {
    width: auto;

    & .containerText {
      & .containerTextHnumber {
        font-size: 50px;
      }
    }
  }
}

@media (max-width: 500px) {
  .containerForm {
    width: auto;

    & .containerText {
      & .containerTextHnumber {
        font-size: 50px;
      }
    }
  }
}
</style>
